import { render, staticRenderFns } from "./StateSwitch.vue?vue&type=template&id=3a0ab5ad&scoped=true"
import script from "./StateSwitch.vue?vue&type=script&lang=ts"
export * from "./StateSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0ab5ad",
  null
  
)

export default component.exports